import { Mesh } from "three";
import { WorldObjectType } from "../../api";
import { DrawableObject } from "./DrawableObject";
export class IfcObject extends DrawableObject {
    constructor(object, objectId) {
        super(object);
        this.object = object;
        this.id = objectId;
    }
    getPhysicalElementIds() {
        return this.object.getPhysicalElementIds();
    }
    getRootElementId() {
        return this.object.getRootElementId();
    }
    getElementIdsOfType(type) {
        return this.object.getElementIdsOfType(type);
    }
    getElementProperties(elementId) {
        return this.object.getElementProperties(elementId);
    }
    applyGroupMaterial(elementIds, material) {
        for (const id of elementIds) {
            this.object.elementMaterials.set(id, material);
        }
        this.object.refreshGroups();
    }
    resetGroupMaterial(elementIds) {
        for (const id of elementIds) {
            this.object.elementMaterials.delete(id);
        }
        this.object.refreshGroups();
    }
    hideGroup(elementIds) {
        for (const id of elementIds) {
            this.object.elementMaterials.set(id, null);
        }
        this.object.refreshGroups();
    }
    resetMaterials() {
        this.object.elementMaterials.clear();
        this.object.refreshGroups();
    }
    applyMaterial(material) {
        this.object.setGlobalMaterial(material);
    }
    setClippingPlanes(planes) {
        this.object.traverse((v) => {
            if (v instanceof Mesh) {
                if (Array.isArray(v.material)) {
                    for (const mat of v.material) {
                        mat.clippingPlanes = planes;
                        mat.needsUpdate = true;
                    }
                }
                else {
                    v.material.clippingPlanes = planes;
                    v.material.needsUpdate = true;
                }
            }
        });
    }
    invalidateMaterials() {
        this.object.traverse((v) => {
            if (v instanceof Mesh) {
                if (Array.isArray(v.material)) {
                    for (const mat of v.material) {
                        mat.needsUpdate = true;
                    }
                }
                else {
                    v.material.needsUpdate = true;
                }
            }
        });
    }
    getEstimatedCenter(center) {
        const box = this.getBoundingVolume();
        if (center !== undefined) {
            center.x = box[0];
            center.y = box[1];
            center.z = box[2];
            return center;
        }
        else {
            return {
                x: box[0],
                y: box[1],
                z: box[2],
            };
        }
    }
    getBoundingVolume() {
        const sphere = this.object.getBoundingSphere();
        return [sphere.center.x, sphere.center.y, sphere.center.z, sphere.radius];
    }
    getObjectType() {
        return WorldObjectType.IfcObject;
    }
    asIfc() {
        return this;
    }
}
